import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ClientAdd } from '@classes/client/addClient';
import { ClientSmartHub } from '@classes/client/client';
import { UserList } from '@classes/user/userlist';
import { faPlus, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ClientService } from '@services/client/client.service';
import { UserService } from '@services/user/user.service';
import { AddClientComponent } from '../add-client/add-client.component';
import { AddUsersComponent } from '../add-users/add-users.component';

@Component({
  selector: 'app-admin-clients',
  templateUrl: './admin-clients.component.html',
  styleUrls: ['./admin-clients.component.scss'],
})
export class AdminClientsComponent implements OnInit {
  faPlus = faPlus;
  faSearch = faSearch;
  users: UserList[];
  show = true;
  clients: ClientSmartHub[];
  displayedColumns: string[] = ['name', 'applicationList', 'isActive'];
  dataSource: MatTableDataSource<ClientSmartHub>;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  length: number;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];

  constructor(
    private clientService: ClientService,
    private dialog: MatDialog,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.getAllClient();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openDialogAddClients(): void {
    const dialogRef = this.dialog.open(AddClientComponent, {
      height: '80vh',
      width: '60%',
    });

    dialogRef.afterClosed().subscribe(() => {
      // this.getAllClient();
    });
  }

  // openDialogAddUsers(client: ClientSmartHub): void {
  //   const dialogRef = this.dialog.open(AddUsersComponent, { disableClose: true, data: { client } });
  //   dialogRef.afterClosed().subscribe(res => {
  //     this.getListusers();
  //   });

  // }

  private getAllClient(): void {
    this.clientService.getAllClients().subscribe((res) => {
      this.clients = res;

      this.dataSource = new MatTableDataSource<ClientSmartHub>(this.clients);

      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }
}
